<template>

    <b-container fluid class="container-layout">
        <b-row align-h="center">
            <p class="title-califica">¿Qué dificultad tuvieron para ti, los Módulos del Examen Simulacro?</p>
        </b-row>
        <b-row class="mt-2" align-h="center">
            <b-col cols="10">
            <b-table-simple class="table-result-califica" striped hover responsive>

                <b-thead class="thead-table-califica">
                    <b-tr>
                        <b-th class="table-th-1 text-center" rowspan="2" colspan="2">MÓDULO</b-th>
                    </b-tr>
                    <b-tr>
                        <b-th class="text-center th-border-1">MUY DIFICIL</b-th>
                        <b-th class="th-border-1 th-border-2 text-center">DIFICIL</b-th>
                        <b-th class="th-border-1 th-border-2 text-center">NORMAL</b-th>
                        <b-th class="th-border-2 th-border-1 text-center">FÁCIL</b-th>
                        <b-th class="text-center  th-border-1 ">MUY FÁCIL</b-th>

                    </b-tr>
                </b-thead>
                <b-tbody class="body-result">
                    <tr class="puntajes-module-califica" v-for="(item, key) in modulos" :key="key">
                        <td class="title-module-califica" colspan="2">{{item.titulo}}</td>
                        <td v-for="(items,index) in 5" :key="index">
                            <b-form-radio :value='{ "modulo": item.id_modulo, "valor": index}' v-model="calificacion[key]" :name="'modulo'+key">
                            </b-form-radio>
                        </td>

                    </tr>
                </b-tbody>

            </b-table-simple>
            </b-col>
        </b-row>
        <b-row align-h="center">
            <p class="title-califica">Califica tu Experiencia en el Examen Simulacro</p>
        </b-row>
        <b-row align-h="center">
            <star-rating v-model="rating" :padding="2" :star-size="30" text-class="start" :border-width="5"></star-rating>
        </b-row>

        <b-row align-h="center">
            <p class="title-califica">¿Qué crees que le faltó o le agregarías al Examen Simulacro?</p>
        </b-row>

        <b-row align-h="center" class="mt-4">
            <b-col sm="9">
                <b-form-textarea v-model="sugerencia" id="textarea-large" size="lg"
                    placeholder="Escriba aqui sus sugerencias"></b-form-textarea>
            </b-col>
        </b-row>
        <b-row align-h="center" class="mt-4">
            <button @click="finalizar()" type="button" class="mt-3 calificar-button">Finalizar</button>
        </b-row>
          <semipolar-spinner
    v-if="loaded"
    class="spinner"
  :animation-duration="2000"
  :size="80"
  color="#0F376E"
/>
    </b-container>
</template>

<script>
    import StarRating from 'vue-star-rating'
   import { SemipolarSpinner  } from 'epic-spinners'


    export default {
        name: 'Calificar',
        components: {
            StarRating,
            SemipolarSpinner
        },
        data: () => ({
              loaded:false,
            calificacion: [],
             valor: [],
            modulos: '',
            rating: 0,
            sugerencia: ' '
        }),
        created() {
            this.getmodulos()
        },
        methods: {
        
            getmodulos() {
                     let data= {
                id_simulacro: localStorage.getItem('id_simulacro'),
                id_carrera: localStorage.getItem('id_carrera'),
            }
                this.$store.dispatch('getModulosxSimulacro', data)
                    .then((response) => {
                        console.log(response.data)
                        this.modulos = response.data.modulo
                    })

            },
            finalizar() {
                   this.loaded=true
                let key = JSON.parse(localStorage.getItem('estudiante'))
                let id_estudiante = key.id
                key = key.key_simulacro
                let data = {
                    sugerencia: this.sugerencia,
                    rating: this.rating,
                    calificacion: this.calificacion,
                    key: key,
                    id_estudiante:id_estudiante,
                }
                this.$store.dispatch('PostCalificar', data)
                    .then((response) => {
                        
                        if(response.data.satisfaccion){
                            localStorage.clear()
                            this.$store.commit('start', 'student')
                              this.loaded=false
                            this.$router.push("/")

                        }
                        
                        })
            }

        },
        computed: {

        }
    }
</script>
<style scoped>
</style>